export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13840.cb0a28b5.jpg";